module.exports = "<p>\n  add-org works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/org/add-org/add-org.component.html
// module id = ../../../../../src/app/org/add-org/add-org.component.html
// module chunks = main